import React from "react";
import "./Header.css";

export default ({ icon, title }) => (
	<div className="Header">
		{icon}
		{title}
	</div>
);
